var _rect, _path, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 30,
    fill: "#FFF0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 40l49-8 9 49-49 8-16-16z",
    fill: "#FF4A4A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 54,
    r: 5,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 74,
    fontFamily: "Arial",
    fontSize: 32,
    fontWeight: 800,
    fill: "white"
  }, "%")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.97869eab6462dd1220657b3644697452.svg";
export { ForwardRef as ReactComponent };